<script>
import {defineComponent} from 'vue'
import router from "../router";

export default defineComponent({
  name: "success",
  data(){
    return{

    }
  },
  methods:{
    go(){
      router.replace(
        {
          name:'profile'
        }
      )
    }
  }
})
</script>

<template>
  <div>
    <b-container fluid class="ok">
      <b-row>
        <b-col>
          <div style="text-align: center;font-size: 40px;font-weight: bold;margin-top: 200px">Payment failed</div>
          <div style="text-align: center">
            <b-button variant="outline-primary" style="margin-top: 50px" @click="go()">Go Back</b-button>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<style scoped>
@media screen and (min-width: 900px) {
  .ok>.row{
    margin-left: 200px;
    margin-right: 200px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/cancel.vue